import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';
import peeelImage from '../assets/images/peeel.png';

function Navigation() {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const location = useLocation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <nav className={`navbar ${theme}`}>
            {location.pathname !== '/' && (
                <div className="navbar-left">
                    <button onClick={handleBackClick} className="back-button">
                        &lt;
                    </button>
                </div>
            )}
            <div className="navbar-brand">
                <Link to="/" className="brand-link">
                    <img src={peeelImage} alt="🍑 Peeel" className="logo" />
                </Link>
            </div>
            <div className="navbar-links">
                {/* Theme Toggle Button */}
                {/*<button className="theme-toggle-btn" onClick={toggleTheme}>*/}
                {/*    {theme === 'day' ? (*/}
                {/*        <i className="fas fa-moon"></i>*/}
                {/*    ) : (*/}
                {/*        <i className="fas fa-sun"></i>*/}
                {/*    )}*/}
                {/*</button>*/}
            </div>
        </nav>
    );
}

export default Navigation;